<div
  class="filter-wrapper"
  [ngClass]="{ disabled: isDisabled }"
  (click)="clearFilter()"
>
  <img
    class="filter-icon"
    alt="filter"
    [ngClass]="{ disabled: isDisabled }"
    [src]="isDisabled ? IMAGES.FILTER_INACTIVE : IMAGES.FILTER_ACTIVE"
  />
  <div class="text">
    {{ DISP_CONSTS.BUTTON_TEXT }}
  </div>
</div>
